// Ціна/телефон/порівняння — з єдиного джерела правди:
// wp-content/themes/rebus-tailwind-twentythree/config/pricing.json
// (згенеровано в ../config/pricing.generated.json скриптом scripts/copyPricing.js)
import pricing from "../config/pricing.generated.json";

export const testData = {
  status: "ok",
  tasks: {
    cards: [
      { id: "1", type: "read", word: "офлайн" },
      { id: "2", templateId: "YakHratysya", type: "info-page" },
      { id: "3", syllables: "какиконанино", type: "syllables" },
      { id: "4", syllables: "лалилілобава", type: "syllables" },
      { id: "5", syllables: "рариріромапа", type: "syllables" },
      { id: "6", syllables: "татитозасоя", type: "syllables" },
      { id: "7", templateId: "ShchoDali", type: "info-page" },
      { id: "8", type: "read", word: "коза" },
      { id: "9", type: "read", word: "коло" },
      { id: "10", type: "read", word: "мама" },
      { id: "11", type: "read", word: "риба" },
      { id: "12", type: "read", word: "сова" },
      { id: "13", type: "read", word: "тато" },
      { id: "14", type: "read", word: "яма" },
      { id: "15", templateId: "Chudovo", type: "info-page" },
      { id: "16", type: "read", word: "валіза" },
      { id: "17", type: "read", word: "калина" },
      { id: "18", type: "read", word: "корова" },
      { id: "19", type: "read", word: "ялина" },
      { id: "20", type: "read", word: "малина" },
      { id: "21", type: "read", word: "собака" },
      { id: "22", type: "read", word: "сорока" },
      { id: "23", templateId: "VyajavlyayetsyaMozhemoITry", type: "info-page" },
      {
        id: "24",
        templateId: "YakschoVazhkoZbahnutyPryntzyp",
        type: "info-page",
      },
    ],
    id: 1,
  },
  globals: {
    contactPhoneNumber: pricing.contactPhoneNumber,
    maxLesson: 48,
    prices: pricing.prices,
    comparisons: pricing.comparisons,
  },
};
